























import {
    Component,
    Vue
} from 'vue-property-decorator';

@Component
export default class Header extends Vue {
    private menuOpen = true;
    private clickMenu(): void {
        this.menuOpen = !this.menuOpen;
    }
}
